const  formatToDate=(dateString)=>{
  if (!dateString) return ""; // Handle empty or undefined value
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert to 12-hour format and ensure 0 doesn't appear for 12
  hours = hours % 12 || 12;

  return `${day}-${month}-${year}`;
};

const  formatToDateTime=(dateString)=>{
  if (!dateString) return ""; // Handle empty or undefined value
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  // const ampm = hours >= 12 ? "PM" : "AM";

  // // Convert to 12-hour format and ensure 0 doesn't appear for 12
  // hours = hours % 12 || 12;

  return `${day}-${month}-${year} ${hours}:${minutes}`;
};

const  differenceInMinutes=(created_at)=>{

  const createdAt = new Date(created_at);
  const now = new Date();

  // Calculate the difference in milliseconds
  const diffInMilliseconds = now - createdAt;

  // Convert the difference to total minutes
  const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));

  if (diffInMinutes < 60) {
    return `${diffInMinutes} minutes ago`;
  } else {
    // Calculate hours and remaining minutes
    const hours = Math.floor(diffInMinutes / 60);
    const minutes = diffInMinutes % 60;
    return `${hours} hours ${minutes} minutes ago`;
  }
};



const  differenceInMinutesInTwoDate=(created_at,created_at_2)=>{

  const createdAt = new Date(created_at);
  const createdAt_2 = new Date(created_at_2);

  // Calculate the difference in milliseconds
  const diffInMilliseconds = createdAt_2 - createdAt;

  // Convert the difference to total minutes
  const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));

  // if (diffInMinutes < 60) {
    return `${diffInMinutes} Minutes ago`;
  // } else {
  //   // Calculate hours and remaining minutes
  //   const hours = Math.floor(diffInMinutes / 60);
  //   const minutes = diffInMinutes % 60;
  //   return `${hours} hours ${minutes} minutes ago`;
  // }
};


export {formatToDateTime,differenceInMinutes,differenceInMinutesInTwoDate,formatToDate};
  
  